import React, {useState, useEffect,} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import Campo from '../../Components/Campo';
import Header from '../../Components/Header';
import { Spinner  } from "react-awesome-spinners";
import FinderSelect from 'react-finderselect';
import { Web } from '@material-ui/icons';
import { DatePicker, DatePickerInput } from 'rc-datepicker';


export default ({IdConta, IdUse,  InfIdConta, InfIdUse,  ListEsp, setUsuariosContServ, UsuariosContServ,  Dados, Avisando, Fechar, Id, setAlert, setAlertTipo}) => {

const [Titulo, setTitulo] = useState("Pagar Ticket do Aluno");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [Img2, setImg2] = useState("../assets/avatarimg.png");
const [Imgs2, setImgs2] = useState("");
const [Imgs1Res, setImgs1Res] = useState("");
const [Nome, setNome] = useState("");
const [Telefone, setTelefone] = useState("");
const [Mensalidade, setMensalidade] = useState("0000");
const [DiaMes, setDiaMes] = useState("00");
const [DiaMesExt, setDiaMesExt] = useState("00");
const [AtualAno, setAtualAno] = useState("0000"); 
const [QuantApp, setQuantApp] = useState("0000");
const [ValorApp, setValorApp] = useState("0000");
const [End, setEnd] = useState("");
const [Num, setNum] = useState("");
const [Bairro, setBairro] = useState("");
const [Cidade, setCidade] = useState("");
const [Estado, setEstado] = useState("");
const [NomeEmp, setNomeEmp] = useState("");
const [NomeApp, setNomeApp] = useState("");
const [AppLimit, setAppLimit] = useState(false);
const [TokenMP, setTokenMP] = useState("");
const [KeyMP, setKeyMP] = useState("");
const [WebHookMP, setWebHookMP] = useState("");
const [ReceberMP, setReceberMP] = useState(true);
const [TempAti, setTempAti] = useState(0);
const [Porcen, setPorcen] = useState("");
const [DataP, setDataP] = useState(new Date());
const [VerD, setVerD] = useState(false);
const [DataIni, setDataIni] = useState(0);
const [IdContaRes, setIdContaRes] = useState("");
const [Alunos, setAlunos] = useState();
const [ValorTotal, setValorTotal] = useState(0);
const [DataAtual, setDataAtual] = useState(ListEsp.TempLimitAtiv);
const [IdRepr, setIdRepr] = useState("");

useEffect(() => {
  PreencherFormulario()
        }, [ListEsp, Porcen ])

useEffect(() => {
  if(IdContaRes){
    PegandoValor() 
   }       
    }, [IdContaRes])



const PreencherFormulario = () => {
      setNome(Porcen.Nome);
      setTelefone(Porcen.Telefone);
      setDataP(new Date(ListEsp.TempLimitAtiv))
      setIdContaRes(ListEsp.IdAluno)
      setMensalidade(Porcen.Mensalidade);
      setDataAtual(ListEsp.TempLimitAtiv);
      
  } 
  
  
 const handleToggle1 = () => {
    setAppLimit(!AppLimit);
  };
   const handleToggle2 = () => {
    setReceberMP(!ReceberMP);
  };


  const criando = ()=>{
      if(Porcen){
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
       Api.TAPagarTicketAluno(IdConta, IdUse,  InfIdConta, InfIdUse, Porcen, Id, Nome, Telefone, IdContaRes, DataAtual,   Mensalidade,   UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert);
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
        setAlert("Algo Errado.");
        setAlertTipo("danger");
      }
    }
   
  const PegandoValor  = ()=>{

      if (navigator.onLine) {
        setMsgErro("")
         
       Api.TAAlunosDadosPagar(IdContaRes, setPorcen);
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    
  }

const AtualizandoData = ()=>{


     if (DataIni !== 0) {
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
       Api.TATualizandoData(Id, DataIni,  UsuariosContServ, setUsuariosContServ, setMsgErro, setLoading, setAlertTipo, setAlert  );
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
      setMsgErro("Escolha Outra Data")
    }
    
  }
  const ColocarImg2 = (e)=>{
    const reader = new FileReader()
    reader.onload = () => {
      if(reader.readyState === 2) {
        setImg2(reader.result);
      }
    }
   reader.readAsDataURL(e.target.files[0]);
    setImgs2(e.target.files[0]);
  }
  const ExcImg2 = ()=>{
   
    setImgs2("");
    setImg2("../assets/avatarimg.png");
  }

  const datando = async (jsDate, dateString)=>{
              
              
              let currentDate = '';
              let now =new Date(jsDate);
              let Dia = now.getDate();
              let Mes = (now.getMonth()+1);
              let Ano = now.getFullYear();
              Dia = Dia < 10 ? '0'+Dia : Dia;
              Mes = Mes < 10 ? '0'+Mes : Mes;
              currentDate = Ano+'-'+Mes+'-'+Dia;
              let Dat  = new Date(currentDate +" 00:00:00.000").getTime();
              console.log(Dat)
              
              
                setDataP(jsDate)
                setDataIni(Dat)

              
             
          }

        return (
            <>
<div className="content-wrapper">
                <Header 
                Titulo={Titulo}
                Avisando={Avisando}
                Fechar={Fechar}
                />
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
            
              <div className="invoice p-3 mb-3">
              {/* title row */}
              <div className="row">
                <div className="col-12">
                  <h4>
                    <i className="far fa-address-card" /> Aluno 
                  </h4>
                </div>
                {/* /.col */}
              </div>
              {/* info row */}
              <div className="row invoice-info">
                <div className="col-sm-4 invoice-col">
                  <address>
                    {Loading  ?
                    <>
                      <Spinner 
                      size={64}
                      color={"#5d0bf7"}
                      sizeUnit={'px'} 
                      /><br />
                      </>
                      :
                      <>
                    <div className="col-12">
                        <Butao 
                        style={"btn .btn-sm btn-success"}
                        titulo={"Pagar"}
                        onClick={()=>criando()}
                        />  
                    </div><br />
                   
                     {MsgErro !== "" &&
                    <>
                    <div class="alert alert-danger alert-dismissible">
                  
                  <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                  {MsgErro}
                </div>
                   
                    </>
                    }
                    </>
                    }
                    
                  <strong>Data do Vencimento</strong><br />
    
                       <string>{new Date(ListEsp.TempLimitAtiv).toLocaleDateString('pt-BR')}</string><br />
                    
                    <strong>Nome do Aluno</strong><br />
                    <string>{Nome}</string>
                    <br />
                 <strong>Telefone do Aluno</strong><br />
                   <string>{Telefone}</string> 
                    <br />
                 
                     
                  </address>
                    </div>
                      <div className="col-sm-4 invoice-col">
                    <address>
                      {Porcen &&

                      <>
                   <strong style={{fontSize:25}}>Nota de Pagamento</strong><br />
                   <strong>Valor da Mensalidade: </strong>
                   <string>{Porcen.Mensalidade.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</string><br />
                     <strong style={{fontSize:20}}>Valor a Pagar: </strong>
                   <string>{Porcen.Mensalidade.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</string><br />
                      </>
                  
                      }
                  
                    
                    
                    </address>
                   </div>
                    <div className="col-sm-4 invoice-col">
                    <address>
                     
                 
                    </address>
                   </div>
              </div>
              <div className="row no-print">
              </div>
              
            
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}